import React, { FC } from 'react';

import { ESpinnerSize, Spinner } from './Spinner/Spinner';

export const ChunkLoader: FC<React.PropsWithChildren<unknown>> = () => (
    <div className="lcr-margin-t4em">
        <Spinner size={ESpinnerSize.MEDIUM} />
    </div>
);
